import R from 'ramda'

const LIKE_TRIGGER_TYPE = 'LIKE_OF'
const LIKE_DISPLAY_TYPE = 'Like'
const EXISTING_TWEET_ACTION = 'EXISTING_TWEET'

const isLikeWidgetTrigger = R.propEq('type', LIKE_TRIGGER_TYPE)

const convertLikeWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(LIKE_DISPLAY_TYPE),
  action: R.always(EXISTING_TWEET_ACTION),
  value: R.prop('data')
})

export { isLikeWidgetTrigger, convertLikeWidgetTriggerToFormTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/widget-to-form/like.js